import page from '../helpers/page';
import promoCarousel from '../components/promoCarousel';
import alsoChooseCarousel from '../components/alsoChooseCarousel';
import categoryFilter from '../components/categoryFilter';

page(() =>
{
	promoCarousel();
	alsoChooseCarousel();
	categoryFilter();

	const valueInput = document.querySelector('.card-form__input');
    
	const addBtn = document.querySelector('.card-form__btn-add');
	addBtn.addEventListener('click', (e) => { valueInput.value++; });

	const removeBtn = document.querySelector('.card-form__btn-remove');
	removeBtn.addEventListener('click', (e) =>
    {
        console.log(valueInput.value);
        if (valueInput.value > 1)
            valueInput.value--;
	});

	const showAdressesElement = document.querySelector('.card-content__addresses-show');
	const hideAdressesElement = document.querySelector('.card-content__addresses-hide');
	const adressesElement = document.querySelector('.card-content__addresses');
	const hiddenClass = 'card-content__addresses--hidden';

	showAdressesElement.addEventListener('click', (e) => {
		e.target.classList.toggle(hiddenClass);
		hideAdressesElement.classList.toggle(hiddenClass);
		adressesElement.style.maxHeight = `${adressesElement.scrollHeight}px`;
	});


	hideAdressesElement.addEventListener('click', (e) => {
		e.target.classList.toggle(hiddenClass);
		adressesElement.style.maxHeight = '';
		setTimeout(() => {
			showAdressesElement.classList.toggle(hiddenClass);
		}, 490);
	});
});
